export function isFlutter(userAgent) {
    return userAgent?.includes('Flutter Native');
}
